import reduxStore from 'redux/store'
import {RestRequestGET, RestRequestPOST} from 'libs/RestRequest'
import Endpoints from 'constants/Endpoints'
import {clearResource, setResource} from 'redux/actions'
import validateSection from './helpers/validateSection'
import {DemandValidation} from 'constants/DemandValidation'

const _FIRST_PUBLICATION_RESOURCE_ID = "firstPublication";

const publish = async (id = -1) => {

    const setError = () => {
        reduxStore.dispatch(
            setResource('publish', {error: true})
        )
    }

    if (id < 0) {
        setError();
        return null;
    }
    try {
        const res = await RestRequestPOST(Endpoints.PUBLISH_DEMAND(id));
        if (res.success) {
            return res.result;
        }
        setError();
    } catch (error) {
        setError();
    }
    return null;
}

const save = async () => {
    await validateSection(DemandValidation.PUBLICATION);
}


const checkPublishOjs = async (id = -1) => {
    try {
        const res = await RestRequestGET(Endpoints.CHECK_OJS_NOTICE(id))
        reduxStore.dispatch(
            setResource('ojsPublicationStatus', res)
        )
        return res;
    } catch (error) {
    }
}

const clearOjsStatus = () => {
    clearResource('ojsPublicationStatus')
}

const publishOjsNotice = async (id = -1) => {
    try {
        const res = await RestRequestPOST(Endpoints.PUBLISH_OJS_NOTICE(id))
        return res
    } catch (error) {
    }
}

const rollbackOjsNotice = async (id = -1) => {
    try {
        const res = await RestRequestPOST(Endpoints.ROLLBACK_OJS_NOTICE(id))
        return res
    } catch (error) {
    }
}

const markFirstPublication = (demandId) => {
    reduxStore.dispatch(setResource(_FIRST_PUBLICATION_RESOURCE_ID, demandId))
}

const isFirstPublication = (demandId) => {
    const {resources} = reduxStore.getState();
    const curRes = resources[_FIRST_PUBLICATION_RESOURCE_ID];
    if(curRes)
        reduxStore.dispatch(clearResource(_FIRST_PUBLICATION_RESOURCE_ID));
    const result = curRes === demandId;
    return result;
}

const publishExPost = async (id = -1) => {

    const setError = () => {
        reduxStore.dispatch(
            setResource('publish', {error: true})
        )
    }

    if (id < 0) {
        setError();
        return null;
    }
    try {
        const res = await RestRequestPOST(Endpoints.PUBLISH_DEMAND_EX_POST(id));
        if (res.success) {
            return res.result;
        }
        setError();
    } catch (error) {
        setError();
    }
    return null;
}

const backToPreparing = async (id) => {
    const res = await RestRequestPOST(Endpoints.DEMAND_BACK_TO_PREPARING(id));
    if (res.success) {
        return res.result;
    }
}

export default {
    publish,
    save,
    checkPublishOjs,
    publishOjsNotice,
    rollbackOjsNotice,
    clearOjsStatus,
    markFirstPublication,
    isFirstPublication,
    publishExPost,
    backToPreparing
}